import {
  MICHELIN_RECOMMENDATIONS_REQUESTED,
  MICHELIN_RECOMMENDATIONS_RECEIVED,
  MICHELIN_RECOMMENDATIONS_FAILED,
  MICHELIN_RECOMMENDATIONS_RESET,
  HOTEL_CONTENT_REQUESTED,
  HOTEL_CONTENT_RECEIVED,
  HOTEL_CONTENT_FAILED,
} from '../helpers/constants/actionsConstants';

import type { Recommendation, HotelContent } from '../selectors/michelinTypes';

export type MichelinRecommendationsRequestedAction = {
  type: typeof MICHELIN_RECOMMENDATIONS_REQUESTED;
};

export type MichelinRecommendationsReceivedAction = {
  type: typeof MICHELIN_RECOMMENDATIONS_RECEIVED;
  payload: {
    recommendation: Recommendation;
  };
};

export type MichelinRecommendationsFailedAction = {
  type: typeof MICHELIN_RECOMMENDATIONS_FAILED;
};

export type MichelinRecommendationsResetAction = {
  type: typeof MICHELIN_RECOMMENDATIONS_RESET;
};

export type HotelContentRequestedAction = {
  type: typeof HOTEL_CONTENT_REQUESTED;
};

export type HotelContentReceivedAction = {
  type: typeof HOTEL_CONTENT_RECEIVED;
  payload: {
    hotelContent: HotelContent;
  };
};

export type HotelContentFailedAction = {
  type: typeof HOTEL_CONTENT_FAILED;
};

export type MichelinRecommendationsAction =
  | MichelinRecommendationsRequestedAction
  | MichelinRecommendationsReceivedAction
  | MichelinRecommendationsFailedAction
  | MichelinRecommendationsResetAction
  | HotelContentRequestedAction
  | HotelContentReceivedAction
  | HotelContentFailedAction;

export const setMichelinRecommendationsRequested =
  (): MichelinRecommendationsRequestedAction => ({
    type: MICHELIN_RECOMMENDATIONS_REQUESTED,
  });

export const setMichelinRecommendationsReceived = (
  recommendation: Recommendation,
): MichelinRecommendationsReceivedAction => ({
  type: MICHELIN_RECOMMENDATIONS_RECEIVED,
  payload: {
    recommendation,
  },
});

export const setMichelinRecommendationsFailed =
  (): MichelinRecommendationsFailedAction => ({
    type: MICHELIN_RECOMMENDATIONS_FAILED,
  });

export const setMichelinRecommendationsReset =
  (): MichelinRecommendationsResetAction => ({
    type: MICHELIN_RECOMMENDATIONS_RESET,
  });

export const setHotelContentRequested = (): HotelContentRequestedAction => ({
  type: HOTEL_CONTENT_REQUESTED,
});

export const setHotelContentReceived = (
  hotelContent: HotelContent,
): HotelContentReceivedAction => ({
  type: HOTEL_CONTENT_RECEIVED,
  payload: { hotelContent },
});

export const setHotelContentFailed = (): HotelContentFailedAction => ({
  type: HOTEL_CONTENT_FAILED,
});
